import { render, staticRenderFns } from "./InnerChatListItem.vue?vue&type=template&id=40615c33&scoped=true&"
import script from "./InnerChatListItem.vue?vue&type=script&lang=ts&"
export * from "./InnerChatListItem.vue?vue&type=script&lang=ts&"
import style0 from "./InnerChatListItem.vue?vue&type=style&index=0&id=40615c33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40615c33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet,VSpacer})
